module.exports = __webpack_public_path__ + "img/hu.e089b98a.svg";